import React from "react";

const ServiceTerms = () => {
  return (
    <div
      style={{
        paddingTop: "100px",
        paddingLeft: "20%",
        paddingRight: "20%",
        textAlign: "justify",
        color: "#000000",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Termo de Serviço</h1>

      <p>
        O serviço Alpis Studio é fornecido a você pela Codekraft, uma empresa
        brasileira inscrita no Cadastro Nacional de Pessoas Jurídicas (CNPJ/MF)
        com o número 41.356.333/0001-35 e sediada à Avenida Brig Faria Lima,
        2369 andar 11 CJ 1102, CEP 01452-922, São Paulo, SP.
      </p>

      <ol>
        <li>
          <strong>INFORMAÇÕES GERAIS</strong>
          <p>
            Para usar o Alpis Studio, você deve entender e concordar totalmente
            com nossos termos de uso. Portanto, quando você se registrar e optar
            por assinar nosso serviço, consideraremos que você, nosso usuário,
            entendeu e aceitou os termos de uso.
          </p>
          <p>
            Levando em consideração a legislação vigente, de acordo com os
            artigos 1º, 3º e 4º do Código Civil Brasileiro de 2002, você só
            poderá aceitar estes Termos de Serviço e, assim, utilizar o Alpis
            Studio se tiver pelo menos 18 anos de idade e capacidade jurídica.
          </p>
          <p>
            É importante que você saiba que estamos constantemente aprimorando
            nossos sistemas e os serviços que prestamos, e podemos descontinuar
            alguns serviços ou adicionar novos recursos à plataforma. Desta
            forma, chamamos a atenção para o fato de que estes Termos de Serviço
            estão sujeitos a revisões e atualizações de tempos em tempos, sendo
            sua responsabilidade manter-se informado sobre as condições aqui
            estabelecidas.
          </p>
        </li>
        <li>
          <strong>
            USO DO SERVIÇO, PROPRIEDADE INTELECTUAL E CONTEÚDO DOS SERVIÇOS
          </strong>
          <p>
            {" "}
            Para habilitar os serviços prestados pelo Alpis Studio e melhorar
            sua experiência em nossa plataforma, você deverá fornecer alguns
            dados pessoais, que serão processados ​​pelo Alpis Studio, e
            Dedicado a finalidades específicas de acordo com nossa Política de
            Privacidade, Disponível em:
            https://www.alpisstudio.com.br/privacy-overview/
          </p>

          <p>
            A plataforma Alpis Studio e todo o seu conteúdo destina-se
            exclusivamente para uso pessoal e não comercial, sendo os direitos
            de propriedade intelectual da plataforma e suas funcionalidades
            pertencentes exclusivamente a Codekraft. Portanto, é expressamente
            vedado a comercialização, reprodução, modificação, publicação ou
            distribuição, a qualquer título ou forma, da totalidade ou de parte
            das informações oferecidas pelo Alpis Studio, após a assinatura dos
            nossos serviços.
          </p>

          <p>
            A Plataforma Alpis Studio e todo o seu conteúdo são apenas para uso
            pessoal e não comercial, os direitos de propriedade intelectual da
            plataforma e sua funcionalidade pertencem exclusivamente à
            Codekraft. Assim, a comercialização, reprodução, modificação,
            publicação ou distribuir as informações fornecidas pelo Alpis Studio
            em qualquer capacidade ou forma, no todo ou em parte, antes ou após
            a assinatura de nossos serviços é veementimente proíbida.
          </p>

          <p>
            Durante o prazo de sua assinatura, o Alpis Studio concede a você uma
            licença limitada, não exclusiva e intransferível acessar a
            Plataforma e, portanto, sem nenhum outro direito a não além da
            licença limitada estabelecida acima
          </p>

          <p>
            O Alpis Studio não fornece consultoria de investimento ou produtos
            financeiros, nem sua rentabilidade, liquidez, adequação ou risco.
            Assim, ao subscrever o nosso serviço, tenha em atenção que os seus
            são informativos não podem ser traduzidos em termos financeiros,
            jurídicos, fiscais, contábeis ou de qualquer outra natureza,
            portanto, Alpis Studio não será responsável por quaisquer danos
            decorrentes de Use as informações fornecidas na plataforma.
          </p>

          <p>
            <h4>Ao subscrever aos serviços VOCÊ concorda em:</h4>
          </p>

          <p>
            Não acessar (nem tentar acessar) o serviço por qualquer meio que não
            seja através da interface fornecida pela plataforma.
          </p>
          <p>
            Não acessar (nem tentar acessar) o serviço por meio de meios
            automatizados.
          </p>
          <p>
            Não participar de nenhuma atividade que interfira ou interrompa o
            funcionamento do serviço (ou servidores e redes conectados ao
            serviço).
          </p>
          <p>
            Não reproduzir, duplicar, copiar, vender, comercializar ou revender
            o serviço para qualquer efeito.
          </p>
        </li>
        <li>
          <strong>PERÍODO DE UTILIZAÇÃO GRATUITA</strong>
          <p>
            Sua assinatura do Alpis Studio pode começar com um período de teste
            gratuito, este período será executado por trinta dias e é projetado
            para dar aos novos e potenciais clientes uma amostra das
            funcionalidades do Alpis Studio. A distribuição de licenças para uso
            gratuito fica a critério exclusivo do Alpis Studio. Direito
            discricionário, que pode ser retirado a qualquer momento se você não
            for mais elegível para receber essas informações ou benefícios.
          </p>
          <p>
            A qualificação do cliente para o período de teste gratuito é
            determinada pelo Alpis Studio e pode ser limitado para evitar o
            abuso do período gratuito, o que significa que o Alpis Studio
            reserva o direito de retirar o acesso gratuito e suspender sua conta
            se determinarmos que você não está qualificado.{" "}
          </p>
          <p>
            Após o período gratuito, se você concordar expressamente em se
            inscrever serviço Alpis Studio, você será cobrado pelo plano usando
            o método de pagamento associado na plataforma.
          </p>
        </li>
        <li>
          <strong>CONDIÇÕES DE CANCELAMENTO</strong>
          <p>
            <strong>Plano Mensal</strong>
          </p>
          <p>
            Você pode cancelar sua assinatura mensal a qualquer momento e
            continuará tendo acesso ao serviço até o final do período de
            assinatura. Para cancelar, acesse a página Minha conta e siga as
            instruções de cancelamento. Se você cancelar sua assinatura, sua
            conta será encerrada automaticamente no final do período de
            cobrança. De acordo com a legislação vigente, a Alpis Studio não
            oferece reembolsos ou créditos por períodos de assinatura usado
            parcialmente.{" "}
          </p>

          <p>
            <strong>Plano Anual</strong>
          </p>
          <p>
            Você pode cancelar sua assinatura anual do Alpis Sutdio a qualquer
            momento e continuará acessando os serviços do Alpis Studio até que o
            período de cobrança mensal expire. O cancelamento da assinatura
            anual não dará direito ao reembolso integral do valor pago, sujeito
            a estorno de valor proporcional ao período utilizado, baseado em
            plano mensal equivalente com multas equivalente a 20% (vinte por
            cento) do total do plano contratado.
          </p>

          <p>
            <strong>Reembolso</strong>
          </p>
          <p>
            O reembolso será feito por depósito em conta bancária ou PIX em até
            60 (sessenta) dias após o pedido de reembolso. Independentemente do
            plano contratual, conforme legislação vigente, se você adquirir um
            plano de serviço e poderá cancelar o contrato no prazo de 7 (sete)
            dias. Nesse caso, um reembolso total será feito e cobrado no cartão
            de crédito usado para a compra. No prazo de 60 (sessenta) dias a
            contar da solicitação.{" "}
          </p>
          <p>
            O Alpis Studio pode cancelar sua assinatura a qualquer momento se:
          </p>
          <p>
            Ocorra violação de qualquer disposição destes Termos de Serviço;
          </p>
          <p>For exigido por Órgãos estatutários e/ou autoridade legais;</p>
          <p>
            A critério exclusivo da Empresa, os serviços prestados pela Alpis
            Studio ao Usuário já não forem mais comercialmente viáveis.
          </p>
        </li>
        <li>
          <strong>SEGURANÇA DA CONTA E OUTROS</strong>
          <p>
            O Alpis Studio está empenhado em garantir que as informações
            pessoais de seus usuários e potenciais usuários sejam armazenados de
            forma a garantir proteção, privacidade, integridade, disponibilidade
            e confidencialidade. Por isso, utiliza a melhor tecnologia de
            segurança da informação e busca reduzir eventos que acontecem em seu
            ambiente digital.
          </p>

          <p>
            No entanto, a segurança de suas informações pessoais também depende
            da segurança de seu computador, dispositivo ou rede e o nível de
            segurança que você usa para proteger seus dados de autenticação
            (nomes de login e senhas).
          </p>

          <p>
            Assim, você concorda e entende que é sua responsabilidade gerenciar
            suas informações por conta própria, manter a confidencialidade das
            senhas associadas a qualquer conta que você usa para nos acessar
            serviço, você é o único responsável pelas atividades que ocorrem em
            sua conta.{" "}
          </p>
          <p>
            Por favor, avise-nos imediatamente se você tomar conhecimento de
            qualquer uso não autorizado de sua senha ou conta, pelo e-mail:
            contato@alpisstudio.com ou privacy@alpisstudio.com para que possamos
            tomar as devidas providências.
          </p>
        </li>
        <li>
          <strong>PRIVACIDADE E INFORMAÇÕES PESSOAIS</strong>
          <p>
            O Alpis Studio é uma plataforma preocupada com a segurança e
            privacidade dos dados pessoais dos seus clientes, clientes em
            potencial e trata essas informações com transparência. Para melhores
            informações a respeito de como tratamos essas informações e conhecer
            nossas práticas de proteção de dados pessoais, acesse nossa Política
            de Privacidade em: https://www.alpisstudio.com.br/privacy-overview/
          </p>

          <p>
            Ao registar-se e optar por subscrever os nossos serviços, ser-lhe-á
            pedido consentimento para o processamento de seus dados pessoais,
            caso em que consideraremos seu Aceite de livre, inequívoca e
            informada com o tratamento dos seus dados pessoais pelo Alpis
            Studio.
          </p>
        </li>
        <li>
          <strong>COMUNICAÇÕES ELETRÔNICAS</strong>
          <p>
            Mantenha seu e-mail de cadastro sempre atualizado e correto, pois o
            utilizamos como meio de comunicação para transmitir informações
            relacionadas à sua conta, tais como: autorização de pagamento,
            débito, confirmação de alteração de senha ou forma de pagamento.{" "}
          </p>
          <p>
            Não enviamos solicitações de informações pessoais, senhas ou códigos
            de segurança por e-mail. Também não exigimos instalação de software
            ou atualizações de aplicativos por e-mail. Se você suspeitar que foi
            enviado um e-mail solicitando informações confidenciais em nome do
            Alpis Studio, NÃO CONFIE e nos informe imediatamente pelo e-mail em:
            privacy@alpisstudio.com.br para que possamos tomar as medidas
            necessárias.
          </p>
        </li>
        <li>
          <strong>LEGISLAÇÃO APLICÁVEL E FORO</strong>
          <p>
            O presente Termo de Serviço rege-se pela legislação da República
            Federativa do Brasil. Sendo o foro da Comarca de Itajaí – SC eleito
            como responsável por dirimir reclamações ou controvérsias
            decorrentes do mesmo.
          </p>
        </li>
      </ol>
    </div>
  );
};

export default ServiceTerms;
